import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaiementMethodAttributeFilter } from 'app/shared/ui/models/paiement-method-attribute-filter';
import { UserTypology } from '../../../../../../models/enums/user-typology.model';

@Component({
  selector: 'jhi-paiement-method-filter',
  templateUrl: './paiement-method-filter.component.html',
  styleUrls: ['./paiement-method-filter.component.scss'],
})
export class PaiementMethodFilterComponent {
  @Input() filter!: PaiementMethodAttributeFilter;
  @Output() filterChange = new EventEmitter<PaiementMethodAttributeFilter>();
  public userTypology = UserTypology;
}
